
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/designer/[designerValue]",
      function () {
        return require("private-next-pages/sneakers/designer/[designerValue].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/designer/[designerValue]"])
      });
    }
  